import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    name: 'Pushes',
    methods:{
        ...mapActions({
          fetchPushesData: "pushes/FETCH_PUSHES_DATA",
        }),
        ...mapMutations({
            changePushesStatus: "pushes/CHANGE_PUSHES_STATUS",
        }),
        handleClose() {
            this.changePushesStatus(false)
            sessionStorage.setItem('pushesShown', 'true')
        }
    },
    computed: {
        ...mapGetters({
            pushesData: 'pushes/pushesData',
            showPushes: 'pushes/showPushes',
        }),
        isCountrySelected() {
            return !!localStorage.getItem('country')
        }
    },
    async created () {
        // Check if pushes have already been shown in this session
        const pushesShown = sessionStorage.getItem('pushesShown')
        if (pushesShown) {
            return
        }

        const [response] = await Promise.all([
            this.fetchPushesData()
        ])
        if (response && response.length > 0) {
            setTimeout(() => {
                this.changePushesStatus(true)
                sessionStorage.setItem('pushesShown', 'true')
            }, 5000)
        }
    }
}
